import { useState, useEffect } from "react";
import React from "react";
import ButtonLiens from "../divers/ButtonLiens";

export const ButtonQuiz = () => {
  const [shiftQuiz, setShiftQuiz] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // même seuil que ton ScrollToTop
        setShiftQuiz(true);
      } else {
        setShiftQuiz(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`quiz-float d-none d-md-block ${shiftQuiz ? "shifted" : ""}`}
    >
      <ButtonLiens
        buttonLink="https://tally.so/r/w4lvaO"
        buttonTarget="_blank"
        rel="noopener noreferrer"
        className="btn"
        buttonText="Audit gratuit"
      />
    </div>
  );
};
